import { useWorkflowContext } from "@/contexts/WorkflowContext";

export function useCurrentWorkflow() {
    return useWorkflowContext();
}
